import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Controller, Scene } from 'react-scrollmagic';

import CalendarIcon from './icons/calendar';
import CreateIcon from './icons/create';
import DeployIcon from './icons/deploy';
import Line from './icons/line';
import PayIcon from './icons/pay';
import SectionTitle from './section-title';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(23, 0),
    color: theme.palette.common.white,
    backgroundColor: theme.colors.footerBackgroundColor,
    '& .d0': {
      transitionDelay: '0.4s'
    },
    '& .d1': {
      transitionDelay: '0.7s'
    },
    '& .d2': {
      transitionDelay: '1.0s'
    },
    '& .d3': {
      transitionDelay: '1.3s'
    },
    '& .d4': {
      transitionDelay: '1.5s'
    }
  },
  animate: {
    position: 'relative',
    top: 20,
    transition:
      'opacity 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955), top 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955)',
    opacity: 0
  },
  show: {
    top: 0,
    opacity: 1
  },
  title: {
    marginBottom: theme.spacing(14),
    transitionDelay: '0.1s'
  },
  line: {
    paddingBottom: theme.spacing(14),
    '& svg': {
      width: '100%'
    }
  },
  contentItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& svg': {
      marginBottom: theme.spacing(4),
      fontSize: 65
    }
  },
  contentTitle: {
    marginBottom: theme.spacing(4),
    fontSize: 20,
    fontWeight: 700,
    lineHeight: 2.16
  },
  contentDescr: {
    width: '100%'
  }
}));

const data = [
  {
    title: 'whiteLabelPage.processWork.delivery.title',
    descr: 'whiteLabelPage.processWork.delivery.descr',
    icon: <CalendarIcon />
  },
  {
    title: 'whiteLabelPage.processWork.create.title',
    descr: 'whiteLabelPage.processWork.create.descr',
    icon: <CreateIcon />
  },
  {
    title: 'whiteLabelPage.processWork.pay.title',
    descr: 'whiteLabelPage.processWork.pay.descr',
    icon: <PayIcon />
  },
  {
    title: 'whiteLabelPage.processWork.deploy.title',
    descr: 'whiteLabelPage.processWork.deploy.descr',
    icon: <DeployIcon />
  }
];

const ProcessWorkContent = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <section className={classes.root}>
      <Container maxWidth="xl">
        <Controller>
          <Scene
            classToggle={[`.${classes.animate}`, `${classes.show}`]}
            triggerElement="#whiteLabelPW"
            indicators={false}
            reverse={false}
            offset="-200px"
          >
            <div id="whiteLabelPW">
              <SectionTitle
                title={t('whiteLabelPage.processWork.title')}
                className={clsx(classes.title, classes.animate)}
              />
              <div className={clsx('d0', classes.animate)}>
                <Hidden smDown>
                  <div className={classes.line}>
                    <Line />
                  </div>
                </Hidden>
              </div>
              <Grid container spacing={10}>
                {data.map((card, index) => {
                  return (
                    <Grid
                      key={index}
                      item
                      xs={12}
                      sm={6}
                      md={3}
                      className={clsx(`d${index}`, classes.animate)}
                    >
                      <div className={classes.contentItem}>
                        {card.icon}
                        <Typography
                          className={classes.contentTitle}
                          variant="h4"
                          align="center"
                        >
                          {t(card.title)}
                        </Typography>
                        <Typography
                          className={classes.contentDescr}
                          variant="body1"
                          align="center"
                        >
                          {t(card.descr)}
                        </Typography>
                      </div>
                    </Grid>
                  );
                })}
              </Grid>
            </div>
          </Scene>
        </Controller>
      </Container>
    </section>
  );
};

export default ProcessWorkContent;
